var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"contact-us"},[_c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"text-lowercase",attrs:{"text":"","color":"primary","href":"mailto:info@aikiu.cloud"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"secondary"}},[_vm._v("mdi-email")]),_vm._v("info@aikiu.cloud")],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }